import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const InfoDialog = ({ children, title, open, handleClose }) => {
  const { t } = useTranslation();

  return (
    <MuiDialog open={open} onClose={handleClose}>
      <MuiDialogTitle sx={{ fontSize: "17px", fontWeight: 400 }}>
        {t("studyRecruitment.infoDialog.prefix")} {title}
      </MuiDialogTitle>
      <MuiDialogContent dividers>{children}</MuiDialogContent>
      <MuiDialogActions>
        <MuiButton onClick={handleClose} sx={{ fontSize: "17px" }}>
          {t("buttons.caps.close")}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default InfoDialog;
